import type { ComponentProps } from 'react'
import { cn } from '@/lib/utils'

export function Input({ className, type, autoFocus, ...props }: ComponentProps<'input'>) {
  return (
    <input
      data-slot="input"
      type={type}
      className={cn(
        'min-h-12 w-full min-w-0 rounded-lg border border-input bg-foreground/3 px-4 py-2.5 text-base text-foreground outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring aria-invalid:border-destructive aria-invalid:focus-visible:border-destructive aria-invalid:focus-visible:outline-destructive disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
      // biome-ignore lint/a11y/noAutofocus: Preserve requested desktop focus; touch users focus by tapping.
      autoFocus={autoFocus && !window.matchMedia('(pointer: coarse)').matches}
    />
  )
}
